import React from "react";
import { useLang } from "@/context/LanguageContext";
import SymbolPage from "@/components/SymbolPage";

const IMG = "https://images.unsplash.com/photo-1714976694525-71eb29a7c500?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const Autisme = () => {
  const { t } = useLang();
  return <SymbolPage data={t.autisme} image={IMG} />;
};

export default Autisme;
